export default "__VITE_ASSET__4de995c3__"